import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';
import EnvironmentManager from 'Utils/environmentManager';

const InsufficientFunds = props => {
  const buttonConfig = {
    primary: {
      label: 'KUPONU KAYDET',
      onClick: props.onPrimaryButtonClick
    },
    secondary: {
      label: EnvironmentManager.getMessageText({ key: 'failed_coupon_balance_not_enough_deposit_button_text' }),
      onClick: props.onSecondaryButtonClick
    }
  };
  return (
    <Message type="none" buttonConfig={ buttonConfig }>
      <p>Bu kuponu oynayabilmek için bakiyen yeterli değil.</p>
    </Message>
  );
};

InsufficientFunds.propTypes = {
  onPrimaryButtonClick: PropTypes.func.isRequired,
  onSecondaryButtonClick: PropTypes.func.isRequired
};

export default InsufficientFunds;
